module.exports = __webpack_public_path__ + "img/09-326x184-paes.5c01ab79.jpg";